import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from "../../nest-api";
import { RequestEmergencysListingDto, RequestEmergencysViewDto } from '../dto/emergencys.dto';

@Injectable()
export class EmergencysNestApi {

  private service: string = '';
  private model: string = 'Emergencys';

  constructor(
    public nestApiProvider: NestApiProvider,
  ) {
  }

  public listing(payload: RequestEmergencysListingDto): Observable<any> {
    const method: string = 'GET';
    const func: string = 'listing';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public view(payload: RequestEmergencysViewDto): Observable<any> {
    const method: string = 'GET';
    const func: string = 'view';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }


}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/emergencys.api.ts